export default {
    '1a-diagram3': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
        'element_3_1': 'Businesses are unlikely to adopt electronic filing in the near future',
        'element_3_2': 'Decision makers don’t think filing is a problem',
        'element_3_3': 'Using them would require costly behavioral change',
        'element_3_4': 'Systems available are expensive, not very effective',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1a/diagram3/i18n/en.js